<template>
  <div>
    <div>
      <div class="ts-flex ts-justify-end ts-space-x-3">
        <ts-button
          color="primary"
          :waiting="exporting"
          @click.prevent="onExportExcel"
        >
          <i class="fas fa-file-excel"></i>
        </ts-button>
        <a-select
          v-model="location"
          style="width: 250px"
          showSearch
          mode="multiple"
          :placeholder="$t('location')"
          :maxTagTextLength="17"
          :maxTagCount="1"
          :filterOption="
            (input, option) =>
              option.componentOptions.children[0].text
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
          "
          @change="fetchData()"
        >
          <a-select-option
            v-for="(l, index) in locations"
            :key="index"
            :value="l.location_id"
          >
            {{ l.location_name_en }}
          </a-select-option>
        </a-select>
        <a-checkbox-group
          v-model="snStatusId"
          @change="fetchData"
          class="ts-mt-2"
          style="margin-right: 18px"
        >
          <a-row>
            <a-col :span="12">
              <a-checkbox :value="1">
                {{ $t('productCost.inStorage') }}
              </a-checkbox>
            </a-col>
            <a-col :span="12" class="ts-flex ts-whitespace-no-wrap">
              <a-checkbox :value="3">
                {{ $t('productCost.availableForSale') }}
              </a-checkbox>
            </a-col>
          </a-row>
        </a-checkbox-group>
        <!-- <a-radio-group
            v-model="snStatusId"
            :default-value="1"
            button-style="solid"
            @change="fetchData()"
          >
            <a-radio-button :value="undefined">
              {{ $t('productCost.all') }}
            </a-radio-button>
            <a-radio-button :value="1">
              {{ $t('productCost.inStorage') }}
            </a-radio-button>
            <a-radio-button :value="3">
              {{ $t('productCost.availableForSale') }}
            </a-radio-button>
          </a-radio-group> -->
        <ts-input
          v-model="search"
          :placeholder="$t('productCost.search')"
          style="width: 250px"
          class="inline-block"
        />
      </div>
    </div>
    <ts-table
      :columns="columns"
      :records="resources"
      :loading="loading"
      class="mt-4"
      expandable
    >
      <template v-slot="{ record }">
        <td>{{ record.location_name_en }}</td>
        <td>{{ record.serial_no }}</td>
        <td>{{ record.barcode }}</td>
        <td>{{ record.product_name_en }}</td>
        <td>{{ record.uom_name_en }}</td>
        <td class="ts-text-center">{{ record.product_grade }}</td>
        <td class="ts-text-right">{{ $defaultCurrencyWithCode(record.cost) }}</td>
        <td class="ts-text-right">{{ $defaultCurrencyWithCode(record.repair_cost) }}</td>
        <td class="ts-text-right">{{ $defaultCurrencyWithCode(record.total_cost) }}</td>
        <td class="ts-text-right">{{ $defaultCurrencyWithCode(record.sale_price) }}</td>
        <td>{{ record.sn_status }}</td>
      </template>
      <template v-slot:expand="{ record }">
        <table class="ts-ml-56">
          <tr class="ts-bg-blue-100">
            <td class="ts-p-0 ts-w-48 ts-whitespace-no-wrap">
              {{ $t('productCost.serial') }}
            </td>
            <td class="ts-p-0 ts-w-32">{{ $t('productCost.barcode') }}</td>
            <td class="ts-p-0 ts-w-56">{{ $t('productCost.productName') }}</td>
            <td class="ts-p-0 ts-w-32">{{ $t('productCost.uom') }}</td>
            <td class="ts-p-0 ts-text-center ts-w-24">
              {{ $t('productCost.grade') }}
            </td>
            <td class="ts-p-0 ts-w-48 ts-text-right">
              {{ $t('productCost.oriCost') }}
            </td>
          </tr>
          <tr
            v-for="(r, index) in record.replacements"
            :key="index"
            class="ts-border-b"
          >
            <td>{{ record.serial_no }}</td>
            <td>{{ r.barcode }}</td>
            <td>{{ r.product_name_en }}</td>
            <td>{{ r.uom_name_en }}</td>
            <td class="ts-text-center">{{ r.grade }}</td>
            <td class="ts-text-right">
              {{ r.cost ? $defaultCurrencyWithCode(r.cost) : 0 }}
            </td>
          </tr>
        </table>
      </template>
    </ts-table>
    <div class="d-flex justify-content-end p-15">
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce, trim } from 'lodash'
import * as FileDownload from 'downloadjs'
export default {
  name: 'serialTableList',
  data () {
    return {
      loading: false,
      exporting: false,
      locations: []
    }
  },
  computed: {
    ...mapState('product/cost', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.product.cost.search
      },
      set (newValue) {
        this.$store.commit('product/cost/SET_SEARCH', newValue)
        this.$store.commit('product/cost/RESET_CURRENT_PAGE')
      }
    },
    snStatusId: {
      get () {
        return this.$store.state.product.cost.serial_list_sn_status_id
      },
      set (newValue) {
        this.$store.commit('product/cost/SET_SERIAL_LIST_SN_STATUS', newValue)
      }
    },
    location: {
      get () {
        return this.$store.state.product.cost.serial_list_location
      },
      set (newValue) {
        this.$store.commit('product/cost/SET_SERIAL_LIST_LOCATION', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('productCost.warehouse') },
        { name: this.$t('productCost.serial') },
        { name: this.$t('productCost.barcode') },
        { name: this.$t('productCost.productName') },
        { name: this.$t('productCost.uom') },
        { name: this.$t('productCost.grade'), style: 'text-align:center' },
        { name: this.$t('productCost.oriCost'), style: 'text-align:right' },
        { name: this.$t('productCost.addCost'), style: 'text-align:right' },
        { name: this.$t('productCost.totalCost'), style: 'text-align:right' },
        { name: this.$t('productCost.price'), style: 'text-align:right' },
        { name: this.$t('productCost.status'), style: 'text-align:left' }
      ]
    }
  },
  created () {
    this.fetchData()
    this.fetchLocation()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('product/cost/fetchSerial', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    async fetchLocation () {
      this.loading = true
      let response = await this.$store.dispatch('product/cost/getFormModel', {
        fnName: 'warehouseAssign'
      })

      this.locations = response.data.warehouseAssign
      this.loading = false
    },
    onExportExcel () {
      this.exporting = true
      this.$store
        .dispatch('product/cost/serialToExcel')
        .then(response => {
          let filename = trim(
            response.headers['content-disposition']
              .substring(
                response.headers['content-disposition'].indexOf('filename')
              )
              .replace('filename=', ''),
            '"'
          )
          FileDownload(response.data, filename)
        })
        .catch(err => {
          let error = JSON.parse(
            String.fromCharCode.apply(null, new Uint8Array(err))
          )
          this.$toasted.error(error.message)
          // this.errors = new Errors(error.errors)
        })
        .finally(() => (this.exporting = false))
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500)
  }
}
</script>
